import { DataPointsQuery } from '@tableau/metrics-engine';

import { RequestHeaders } from '../../httpClient/serverApi/requests/Request';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { GetMetricDataPointsByIdsRequest } from '../serverApi/requests/GetMetricDataPointsByIdsRequest';
import { IMetricDataList } from '../serverApi/types/IMetricDataList';

const query = JSON.stringify(DataPointsQuery.build());

export const MetricDataPoints = {
  getMetricDataPoints(metricIds: string[], headers?: RequestHeaders): Promise<IMetricDataList> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(metricIds, (metricIds) => new GetMetricDataPointsByIdsRequest({metricIds, query}, headers)),
      (results: IMetricDataList[]) => {
        return {
          failures: results.reduce((r, c) => Object.assign(r, c.failures), {}),
          data: results.reduce((r, c) => Object.assign(r, c.data), {}),
        };
      }
    );
  }
};

export type MetricDataPoints = typeof MetricDataPoints;
